// 动态译文管理：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 译文审核
export const management = Object.freeze({
  "businessTranslation.generated": "生成完成",
  "businessTranslation.autoPublish": "自动发布已启用：AI译文校验通过后显示，无需人工审核。",
  "businessTranslation.sellerCompany": "货主公司名称",
  "businessTranslation.productTitle": "商品标题",
  "businessTranslation.mallGoodsId": "商城商品ID（goods_id）",
  "businessTranslation.title": "企业／商品正文译文",
  "businessTranslation.hint":
    "动态译文用于显示，不改业务原文。启用自动发布时，AI译文校验通过后直接发布；仍可人工修订。",
  "businessTranslation.aiHint":
    "AI仅处理正文文字，不发送附件或HTML属性；当前限8个文字节点、合计10000字符，较大正文请使用人工候选。",
  "businessTranslation.transferConfirmation":
    "我确认当前原文允许发送给已配置的翻译模型（不包含未经授权的隐私或合同材料）",
  "businessTranslation.aiUnavailable":
    "生成配置未就绪或正文超出预算，人工候选仍可使用。",
  "businessTranslation.jobs": "最近20条正文生成任务",
  "businessTranslation.jobQueued":
    "已加入后台生成队列，完成后按当前发布策略显示。",
  "businessTranslation.type": "正文类型",
  "businessTranslation.company": "企业介绍",
  "businessTranslation.product": "商品HTML正文",
  "businessTranslation.id": "真实企业／商品库 ID",
  "businessTranslation.approve": "批准已审英文版本",
  "businessTranslation.preview":
    "当前界面语言的显示预览（HTML以源码文字显示）",
  "businessTranslation.NOT_REQUESTED": "中文原文",
  "businessTranslation.NONE": "英文显示译文",
  "businessTranslation.TRANSLATION_MISSING": "暂无可用英文译文，显示原文",
  "businessTranslation.SOURCE_CHANGED": "原文已变，旧译文不能用于显示",
  "businessTranslation.SOURCE_UNLINKED": "尚无可靠的商品库关联，保留原文",
  "businessTranslation.TRANSLATION_UNAVAILABLE": "译文暂不可用，保留原文",
  "contractTranslation.title": "合同译文阅读辅助台账",
  "contractTranslation.hint":
    "仅供管理员核对原件与保存阅读辅助候选，不替代原合同。当前单管理员阶段暂停独立批准，不需要临时创建审核账号。",
  "contractTranslation.id": "真实合同 ID（非合同编号）",
  "contractTranslation.attachments": "关联原件字节摘要",
  "contractTranslation.originalHint":
    "摘要不是附件正文。批准前须通过原合同入口核对真实附件、全部条款和关键事实；本页面未提供不可变原件归档或 OCR 对照。",
  "contractTranslation.note": "审核意见（批准、拒绝均必填）",
  "contractTranslation.facts":
    "我已对照真实原件核验金额、日期、编号、账户及全部条款，确认译文仅为阅读辅助",
  "contractTranslation.approve": "批准阅读辅助（不公开发布）",
  "contractTranslation.empty": "暂无合同译文候选",
  "contractTranslation.PENDING_REVIEW": "待独立审核",
  "contractTranslation.REVIEWED": "已审核阅读辅助",
  "contractTranslation.REJECTED": "已拒绝",
  "contractTranslation.independent":
    "不能审核自己提交的候选；当前单管理员阶段独立批准暂停",
  "contractTranslation.originalUnavailable":
    "真实原件暂不能完整核验，不能提交或批准；可查看已有历史候选",
  "contractTranslation.mismatch": "候选未保留关键事实，请核对原件并提交新候选",
  "contractTranslation.invalid": "请先读取真实合同原件，并填写英文候选",
  "contentTranslation.candidates": "最近20条候选（含人工候选）",
  "contentTranslation.title": "动态译文管理",
  "contentTranslation.category": "商品分类说明",
  "contentTranslation.source": "当前中文原文",
  "contentTranslation.candidateSource": "候选绑定的原文",
  "contentTranslation.english": "英文候选",
  "contentTranslation.generate": "生成英文候选",
  "contentTranslation.manual": "保存人工候选",
  "contentTranslation.refresh": "刷新任务",
  "contentTranslation.jobs": "最近20条生成任务",
  "contentTranslation.open": "对照审核",
  "contentTranslation.approve": "批准并发布",
  "contentTranslation.reject": "拒绝",
  "contentTranslation.note": "审核意见（拒绝时必填）",
  "contentTranslation.empty": "暂无生成任务",
  "contentTranslation.failed": "译文操作失败，请重试",
  "contentTranslation.saved": "候选已保存，尚未公开",
  "contentTranslation.reviewed": "审核决定已保存",
  "contentTranslation.queued": "任务已提交，请刷新查看生成结果",
  "contentTranslation.confirm":
    "请确认已核对术语、数字与料号。批准后，此版本译文将用于公开英文显示。",
  "contentTranslation.stale":
    "原文已变更或候选已终结，不能再次发布。请为当前原文生成新候选。",
  "contentTranslation.disabled":
    "生成版本尚未配置；可保存人工候选，不能猜测模型版本。",
  "contentTranslation.hint":
    "AI只生成待审候选；批准不会修改中文原文。此入口不处理合同或附件。",
  "contentTranslation.PENDING": "待生成",
  "contentTranslation.RUNNING": "生成中",
  "contentTranslation.GENERATED": "待审核",
  "contentTranslation.STALE": "原文已过期",
  "contentTranslation.FAILED": "生成失败",
  "contentTranslation.PUBLISHED": "已发布",
  "contentTranslation.REJECTED": "已拒绝",
  "contentTranslation.invalid": "请选择有原文的分类并填写英文候选",
});

export const messages = Object.freeze({ ...management });
